//src/data/products.js
/**
 * Static product data - matches backend MongoDB structure
 * This file will be replaced with API calls through productService
 */

export const products= [
  {
    id: 'prod-1',
    name: 'Front Brake Disc Rotor',
    slug: 'front-brake-disc-rotor',
    sku: 'BRM-FBD-001-STD',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'BRM-FBD-001',
    category: 'Brake Discs',
    categorySlug: 'brake-discs',
    categoryId: 'brake-discs',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500',
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=500',
    ],
    shortDescription: 'High-performance front brake disc rotor with excellent heat dissipation.',
    description: 'High-performance front brake disc rotor with excellent heat dissipation. Precision-machined for optimal braking performance and longevity.',
    specifications: {
      'Diameter': '280mm',
      'Thickness': '26mm',
      'Material': 'Cast Iron',
      'Type': 'Vented',
      'Weight': '6.2 kg',
    },
    warranty: '2 Years / 40,000 km',
    returnPolicy: '30 days return policy for unused items in original packaging',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Swift', yearRange: '2018-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Baleno', yearRange: '2019-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Dzire', yearRange: '2017-2024' },
    ],
    retailPrice: { mrp: 3999, salePrice: 3499 },
    wholesalePrice: { mrp: 3499, salePrice: 2999 },
    minOrderQty: 1,
    minWholesaleQty: 10,
    status: 'active',
    isFeatured: true,
    vendor: { id: 'v1', vendorName: 'AutoParts Express', rating: 4.8, reviewCount: 234, retailPrice: 3499, wholesalePrice: 2999, minWholesaleQty: 10, inStock: true, stockCount: 45, deliveryDays: '2-3' },
    reviews: [
      { id: 'r1', author: 'Rajesh K.', rating: 5, title: 'Excellent quality', content: 'Perfect fit for my Swift. Braking performance improved significantly.', date: '2024-01-15', verified: true },
      { id: 'r2', author: 'Amit S.', rating: 4, title: 'Good product', content: 'Works well, delivery was quick.', date: '2024-01-10', verified: true },
    ],
  },
  {
    id: 'prod-2',
    name: 'Air Filter Element',
    slug: 'air-filter-element',
    sku: 'MAN-AF-002',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'MAN-AF-002',
    category: 'Air Filters',
    categorySlug: 'air-filter',
    categoryId: 'air-filter',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=500',
    ],
    description: 'Premium quality air filter for optimal engine protection. Filters 99.5% of dust and particles for cleaner engine air intake.',
    specifications: {
      'Length': '245mm',
      'Width': '175mm',
      'Height': '42mm',
      'Filtration': '99.5%',
    },
    warranty: '1 Year / 15,000 km',
    returnPolicy: '15 days return policy for unused items',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Creta', yearRange: '2020-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Venue', yearRange: '2019-2024' },
    ],
    retailPrice: { mrp: 999, salePrice: 899 },
    wholesalePrice: { mrp: 899, salePrice: 749 },
    minOrderQty: 1,
    minWholesaleQty: 20,
    status: 'active',
    isFeatured: true,
    vendor: { id: 'v1', vendorName: 'FilterKing', rating: 4.7, reviewCount: 312, retailPrice: 899, wholesalePrice: 749, minWholesaleQty: 20, inStock: true, stockCount: 150, deliveryDays: '2-3' },
    reviews: [
      { id: 'r1', author: 'Priya M.', rating: 5, title: 'Perfect fit', content: 'Exact replacement for my Creta. Easy to install.', date: '2024-02-01', verified: true },
    ],
  },
  {
    id: 'prod-3',
    name: 'Front Shock Absorber Set',
    slug: 'front-shock-absorber-set',
    sku: 'MON-FSA-003',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'MON-FSA-003',
    category: 'Shock Absorbers',
    categorySlug: 'shock-absorbers',
    categoryId: 'shock-absorbers',
    productType: 'AFTERMARKET',
    images: [
      'https://images.unsplash.com/photo-1619725002198-6a689b72f41d?w=500',
    ],
    description: 'Gas-charged shock absorbers for improved ride comfort and handling. Set of 2 for front suspension.',
    specifications: {
      'Type': 'Gas Charged',
      'Length': '320mm',
      'Stroke': '180mm',
      'Quantity': '2 pcs (Left + Right)',
    },
    warranty: '3 Years / 50,000 km',
    returnPolicy: '30 days return policy',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Nexon', yearRange: '2020-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Punch', yearRange: '2021-2024' },
    ],
    retailPrice: { mrp: 6999, salePrice: 5999 },
    wholesalePrice: { mrp: 5999, salePrice: 5199 },
    minOrderQty: 1,
    minWholesaleQty: 8,
    status: 'active',
    isFeatured: false,
    vendor: { id: 'v1', vendorName: 'SuspensionPro', rating: 4.6, reviewCount: 178, retailPrice: 5999, wholesalePrice: 5199, minWholesaleQty: 8, inStock: true, stockCount: 22, deliveryDays: '3-4' },
    reviews: [
      { id: 'r1', author: 'Vikram P.', rating: 5, title: 'Great improvement', content: 'My Nexon rides like new after installing these.', date: '2024-01-20', verified: true },
    ],
  },
  {
    id: 'prod-4',
    name: 'Headlight Assembly - Left',
    slug: 'headlight-assembly-left',
    sku: 'LMX-HL-004',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'LMX-HL-004',
    category: 'Electricals',
    categorySlug: 'electricals',
    categoryId: 'headlights',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1489824904134-891ab64532f1?w=500',
    ],
    description: 'OEM quality headlight assembly with projector lens. Includes DRL and turn signal.',
    specifications: {
      'Position': 'Left (Driver Side)',
      'Lens Type': 'Projector',
      'Bulb Type': 'H4 Halogen',
      'Features': 'DRL, Turn Signal',
    },
    warranty: '1 Year',
    returnPolicy: '7 days return for manufacturing defects',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'City', yearRange: '2020-2024' },
    ],
    retailPrice: { mrp: 9499, salePrice: 8499 },
    wholesalePrice: { mrp: 8499, salePrice: 7499 },
    minOrderQty: 1,
    minWholesaleQty: 4,
    status: 'active',
    isFeatured: true,
    vendor: { id: 'v1', vendorName: 'LightHouse Auto', rating: 4.9, reviewCount: 267, retailPrice: 8499, wholesalePrice: 7499, minWholesaleQty: 4, inStock: true, stockCount: 15, deliveryDays: '2-3' },
    reviews: [
      { id: 'r1', author: 'Suresh R.', rating: 5, title: 'Perfect OEM quality', content: 'Exact match to the original. Excellent build quality.', date: '2024-02-05', verified: true },
    ],
  },
  {
    id: 'prod-5',
    name: 'Engine Oil Filter',
    slug: 'engine-oil-filter',
    sku: 'BSH-OF-005',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'BSH-OF-005',
    category: 'Oil Filters',
    categorySlug: 'oil-filter',
    categoryId: 'oil-filter',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=500',
    ],
    description: 'Premium spin-on oil filter with anti-drain valve. Removes 99% of contaminants.',
    specifications: {
      'Type': 'Spin-on',
      'Thread Size': 'M20 x 1.5',
      'Height': '85mm',
      'Diameter': '76mm',
    },
    warranty: '1 Year / 10,000 km',
    returnPolicy: '15 days return policy',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Swift', yearRange: '2018-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Baleno', yearRange: '2019-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Innova Crysta', yearRange: '2016-2024' },
    ],
    retailPrice: { mrp: 549, salePrice: 449 },
    wholesalePrice: { mrp: 449, salePrice: 379 },
    minOrderQty: 1,
    minWholesaleQty: 25,
    status: 'active',
    isFeatured: false,
    vendor: { id: 'v1', vendorName: 'FilterKing', rating: 4.7, reviewCount: 312, retailPrice: 449, wholesalePrice: 379, minWholesaleQty: 25, inStock: true, stockCount: 200, deliveryDays: '1-2' },
    reviews: [
      { id: 'r1', author: 'Manoj K.', rating: 5, title: 'Bosch quality', content: 'Always trust Bosch for filters. Perfect fit.', date: '2024-01-25', verified: true },
    ],
  },
  {
    id: 'prod-6',
    name: 'Brake Pad Set - Front',
    slug: 'brake-pad-set-front',
    sku: 'BRM-BP-006',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'BRM-BP-006',
    category: 'Ceramic Pads',
    categorySlug: 'ceramic-pads',
    categoryId: 'ceramic-pads',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500',
    ],
    description: 'High-performance ceramic brake pads with low dust formula. Set of 4 pads for front axle.',
    specifications: {
      'Material': 'Ceramic',
      'Quantity': '4 pcs',
      'Friction Coefficient': '0.35-0.45',
      'Operating Temp': 'Up to 600°C',
    },
    warranty: '2 Years / 30,000 km',
    returnPolicy: '30 days return policy',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Creta', yearRange: '2020-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'i20', yearRange: '2020-2024' },
    ],
    retailPrice: { mrp: 3499, salePrice: 2999 },
    wholesalePrice: { mrp: 2999, salePrice: 2599 },
    minOrderQty: 1,
    minWholesaleQty: 12,
    status: 'active',
    isFeatured: true,
    vendor: { id: 'v1', vendorName: 'BrakeMaster', rating: 4.8, reviewCount: 189, retailPrice: 2999, wholesalePrice: 2599, minWholesaleQty: 12, inStock: true, stockCount: 56, deliveryDays: '2-3' },
    reviews: [
      { id: 'r1', author: 'Arun S.', rating: 5, title: 'Low dust, great stopping', content: 'These ceramic pads are amazing. No more dusty alloys!', date: '2024-02-10', verified: true },
    ],
  },
  {
    id: 'prod-7',
    name: 'Timing Belt Kit',
    slug: 'timing-belt-kit',
    sku: 'GAT-TB-007',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'GAT-TB-007',
    category: 'Engine Parts',
    categorySlug: 'engine-parts',
    categoryId: 'timing-belt',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=500',
    ],
    description: 'Complete timing belt kit including belt, tensioner, and idler pulleys. Essential for engine maintenance.',
    specifications: {
      'Belt Teeth': '127',
      'Belt Width': '25mm',
      'Kit Includes': 'Belt, Tensioner, 2 Idler Pulleys',
    },
    warranty: '2 Years / 60,000 km',
    returnPolicy: '30 days return policy',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'City', yearRange: '2020-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Amaze', yearRange: '2018-2024' },
    ],
    retailPrice: { mrp: 7999, salePrice: 6999 },
    wholesalePrice: { mrp: 6999, salePrice: 5999 },
    minOrderQty: 1,
    minWholesaleQty: 5,
    status: 'active',
    isFeatured: false,
    vendor: { id: 'v1', vendorName: 'EnginePro Parts', rating: 4.7, reviewCount: 145, retailPrice: 6999, wholesalePrice: 5999, minWholesaleQty: 5, inStock: true, stockCount: 18, deliveryDays: '3-4' },
    reviews: [
      { id: 'r1', author: 'Karthik V.', rating: 5, title: 'Complete kit', content: 'Everything you need for timing belt replacement. Quality parts.', date: '2024-01-28', verified: true },
    ],
  },
  {
    id: 'prod-8',
    name: 'Side Mirror - Right',
    slug: 'side-mirror-right',
    sku: 'UNM-SM-008',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'UNM-SM-008',
    category: 'Body Parts',
    categorySlug: 'body-parts',
    categoryId: 'mirrors',
    productType: 'AFTERMARKET',
    images: [
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=500',
    ],
    description: 'Electric side mirror with integrated turn signal. Manual folding with heating function.',
    specifications: {
      'Position': 'Right (Passenger Side)',
      'Adjustment': 'Electric',
      'Features': 'Turn Signal, Heating',
      'Color': 'Primer (Unpainted)',
    },
    warranty: '1 Year',
    returnPolicy: '7 days return for manufacturing defects',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'XUV700', yearRange: '2021-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Scorpio-N', yearRange: '2022-2024' },
    ],
    retailPrice: { mrp: 4999, salePrice: 4299 },
    wholesalePrice: { mrp: 4299, salePrice: 3699 },
    minOrderQty: 1,
    minWholesaleQty: 6,
    status: 'active',
    isFeatured: false,
    vendor: { id: 'v1', vendorName: 'BodyWorks India', rating: 4.6, reviewCount: 98, retailPrice: 4299, wholesalePrice: 3699, minWholesaleQty: 6, inStock: true, stockCount: 14, deliveryDays: '4-5' },
    reviews: [
      { id: 'r1', author: 'Deepak M.', rating: 4, title: 'Good aftermarket option', content: 'Fits well, minor adjustment needed. Good value for money.', date: '2024-02-08', verified: true },
    ],
  },
  {
    id: 'prod-9',
    name: 'Alternator Assembly',
    slug: 'alternator-assembly',
    sku: 'DNS-ALT-009',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'DNS-ALT-009',
    category: 'Electricals',
    categorySlug: 'electricals',
    categoryId: 'alternators',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1489824904134-891ab64532f1?w=500',
    ],
    description: 'Genuine Denso alternator with voltage regulator. High output for modern electrical demands.',
    specifications: {
      'Output': '90A',
      'Voltage': '12V',
      'Pulley Type': 'Serpentine 6-groove',
      'Rotation': 'Clockwise',
    },
    warranty: '2 Years',
    returnPolicy: '30 days return policy',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Innova Crysta', yearRange: '2016-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Fortuner', yearRange: '2016-2024' },
    ],
    retailPrice: { mrp: 14999, salePrice: 12999 },
    wholesalePrice: { mrp: 12999, salePrice: 11499 },
    minOrderQty: 1,
    minWholesaleQty: 3,
    status: 'active',
    isFeatured: true,
    vendor: { id: 'v1', vendorName: 'ElectroParts India', rating: 4.9, reviewCount: 167, retailPrice: 12999, wholesalePrice: 11499, minWholesaleQty: 3, inStock: true, stockCount: 7, deliveryDays: '3-4' },
    reviews: [
      { id: 'r1', author: 'Ravi T.', rating: 5, title: 'Denso quality', content: 'Charging issue completely resolved. Denso is reliable.', date: '2024-01-30', verified: true },
    ],
  },
  {
    id: 'prod-10',
    name: 'Rear Bumper Assembly',
    slug: 'rear-bumper-assembly',
    sku: 'TGP-RB-010',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'TGP-RB-010',
    category: 'Body Parts',
    categorySlug: 'body-parts',
    categoryId: 'bumpers',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=500',
    ],
    description: 'OEM rear bumper with parking sensor provisions. Pre-painted in primer, ready for body color match.',
    specifications: {
      'Material': 'PP Plastic',
      'Finish': 'Primer',
      'Features': 'Parking Sensor Provisions',
      'Fitment': 'Direct Replacement',
    },
    warranty: '1 Year',
    returnPolicy: '7 days return for manufacturing defects',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Nexon', yearRange: '2020-2024' },
    ],
    retailPrice: { mrp: 9499, salePrice: 8499 },
    wholesalePrice: { mrp: 8499, salePrice: 7499 },
    minOrderQty: 1,
    minWholesaleQty: 3,
    status: 'active',
    isFeatured: false,
    vendor: { id: 'v1', vendorName: 'Tata Genuine Store', rating: 4.9, reviewCount: 234, retailPrice: 8499, wholesalePrice: 7499, minWholesaleQty: 3, inStock: true, stockCount: 10, deliveryDays: '3-4' },
    reviews: [
      { id: 'r1', author: 'Sachin P.', rating: 5, title: 'Perfect OEM fit', content: 'Genuine Tata part. Fitted perfectly without any issues.', date: '2024-02-12', verified: true },
    ],
  },
  {
    id: 'prod-11',
    name: 'Fuel Pump Assembly',
    slug: 'fuel-pump-assembly',
    sku: 'BSH-FP-011',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'BSH-FP-011',
    category: 'Engine Parts',
    categorySlug: 'engine-parts',
    categoryId: 'pistons',
    productType: 'OEM',
    images: [
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=500',
    ],
    description: 'In-tank fuel pump assembly with fuel level sender. High pressure output for fuel injection systems.',
    specifications: {
      'Flow Rate': '110 L/hr',
      'Pressure': '3-4 bar',
      'Type': 'In-tank Electric',
      'Includes': 'Pump, Filter, Level Sender',
    },
    warranty: '2 Years',
    returnPolicy: '30 days return policy',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Swift', yearRange: '2018-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Dzire', yearRange: '2017-2024' },
    ],
    retailPrice: { mrp: 5999, salePrice: 4999 },
    wholesalePrice: { mrp: 4999, salePrice: 4299 },
    minOrderQty: 1,
    minWholesaleQty: 6,
    status: 'active',
    isFeatured: true,
    vendor: { id: 'v1', vendorName: 'EnginePro Parts', rating: 4.7, reviewCount: 145, retailPrice: 4999, wholesalePrice: 4299, minWholesaleQty: 6, inStock: true, stockCount: 23, deliveryDays: '2-3' },
    reviews: [
      { id: 'r1', author: 'Anand K.', rating: 5, title: 'Fixed my fuel delivery issue', content: 'Bosch quality. Car runs smooth now.', date: '2024-02-03', verified: true },
    ],
  },
  {
    id: 'prod-12',
    name: 'Control Arm Lower - Front Left',
    slug: 'control-arm-lower-front-left',
    sku: 'MOG-CA-012',
    manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic',
    oemNumber: 'MOG-CA-012',
    category: 'Suspension',
    categorySlug: 'suspension',
    categoryId: 'bushings',
    productType: 'AFTERMARKET',
    images: [
      'https://images.unsplash.com/photo-1619725002198-6a689b72f41d?w=500',
    ],
    description: 'Premium quality lower control arm with pre-installed ball joint. Enhanced durability for Indian road conditions.',
    specifications: {
      'Position': 'Front Left',
      'Material': 'Forged Steel',
      'Ball Joint': 'Pre-installed',
      'Bushings': 'Rubber',
    },
    warranty: '3 Years / 50,000 km',
    returnPolicy: '30 days return policy',
    compatibility: [
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'i20', yearRange: '2020-2024' },
      { manufacturerBrand: 'Generic',
    vehicleBrand: 'Generic', model: 'Venue', yearRange: '2019-2024' },
    ],
    retailPrice: { mrp: 4299, salePrice: 3799 },
    wholesalePrice: { mrp: 3799, salePrice: 3299 },
    minOrderQty: 1,
    minWholesaleQty: 8,
    status: 'active',
    isFeatured: false,
    vendor: { id: 'v1', vendorName: 'EnginePro Parts', rating: 4.7, reviewCount: 156, retailPrice: 4299, wholesalePrice: 3799, minWholesaleQty: 8, inStock: true, stockCount: 42, deliveryDays: '2-3' },
    reviews: [],
  },
];



